import PropTypes from 'prop-types';

export const dateRangeShape = PropTypes.shape({
    endDate: PropTypes.any,
    startDate: PropTypes.any
});

export const merchantProcessorShape = PropTypes.shape({
    id: PropTypes.number,
    merchantId: PropTypes.string,
    processorType: PropTypes.number
});

export const merchantShape = PropTypes.shape({
    currencyId: PropTypes.string.isRequired,
    processor: merchantProcessorShape,
    merchantId: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired
});

export const payoutAccountShape = PropTypes.shape({
    payoutAccountId: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired
});

export const roleShape = PropTypes.shape({
    name: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    role: PropTypes.string.isRequired
});

export const cardTypesShape = PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string
});

export const depositDetailsShape = PropTypes.shape({
    achDetailId: PropTypes.string,
    achSummaryId: PropTypes.number,
    amount: PropTypes.number,
    thirdPartyFundedAmount: PropTypes.number,
    type: PropTypes.number
});

export const locationShape = PropTypes.shape({
    pathname: PropTypes.string,
    search: PropTypes.string,
    hash: PropTypes.string,
    key: PropTypes.string
});

export const chargebackReasonShape = PropTypes.shape({
    name: PropTypes.string,
    description: PropTypes.string
});

export const depositShape = PropTypes.shape({
    amount: PropTypes.number,
    createdAt: PropTypes.string,
    date: PropTypes.string,
    details: PropTypes.arrayOf(depositDetailsShape),
    dda: PropTypes.string,
    id: PropTypes.number,
    merchantId: PropTypes.string,
    updatedAt: PropTypes.string
});

export const batchDetailsShape = PropTypes.shape({
    achDetailId: PropTypes.string,
    achSummary: PropTypes.shape({
        date: PropTypes.any,
        merchantId: PropTypes.string
    }),
    amount: PropTypes.number,
    count: PropTypes.number,
    processor: PropTypes.shape({
        batchRef: PropTypes.string
    })
});

export const chargebacksShape = PropTypes.shape({
    achDetailId: PropTypes.number,
    amount: PropTypes.number,
    authCode: PropTypes.string,
    cardIdentifier: PropTypes.string,
    cardNumber: PropTypes.string,
    cardType: PropTypes.string,
    chargebackCycle: PropTypes.number,
    cycleType: PropTypes.string,
    date: PropTypes.string,
    description: PropTypes.string,
    id: PropTypes.number,
    isDisputed: PropTypes.bool,
    lockBoxBatch: PropTypes.string,
    merchantId: PropTypes.string,
    merchantName: PropTypes.string,
    message: PropTypes.string,
    reason: chargebackReasonShape,
    reasonCode: PropTypes.string,
    referenceNumber: PropTypes.string,
    reportDate: PropTypes.string,
    sequenceNumber: PropTypes.string,
    transactionCode: PropTypes.string,
    transactionDate: PropTypes.string
});

export const recoveriesShape = PropTypes.shape({
    transactionDate: PropTypes.string,
    id: PropTypes.number,
    retryDate: PropTypes.string,
    originalAmount: PropTypes.number,
    originalDeclinePaymentId: PropTypes.string,
    orderNumber: PropTypes.string,
    recoveryStatus: PropTypes.number,
    retryCount: PropTypes.number,
    merchantId: PropTypes.string,
    userName: PropTypes.string,
    isEnabledForRecovery: PropTypes.bool,
    createdAt: PropTypes.string,
    updatedAt: PropTypes.string,
    originalPaymentRequest: PropTypes.string,
    retryMetadata: PropTypes.string,
    retryProviderBody: PropTypes.string
});

export const chargebacksSummaryShape = PropTypes.shape({
    newChargebacksCount: PropTypes.number,
    newChargebacksTotal: PropTypes.number,
    disputedChargebacksCount: PropTypes.number,
    disputedChargebacksTotal: PropTypes.number,
    representmentsCount: PropTypes.number,
    representmentsTotal: PropTypes.number
});

export const disputeShape = PropTypes.shape({
    chargebackId: PropTypes.number,
    id: PropTypes.number,
    merchantId: PropTypes.string
});

export const statementsShape = PropTypes.shape({
    id: PropTypes.number,
    merchantId: PropTypes.string,
    statementDate: PropTypes.string
});

export const adjustmentsShape = PropTypes.shape({
    lockBoxBatch: PropTypes.string,
    merchantId: PropTypes.string,
    netAmount: PropTypes.number,
    reportDate: PropTypes.string
});

export const customerShape = PropTypes.shape({
    address: PropTypes.string,
    address2: PropTypes.string,
    city: PropTypes.string,
    company: PropTypes.string,
    country: PropTypes.string,
    firstName: PropTypes.string,
    id: PropTypes.number,
    lastName: PropTypes.string,
    phone: PropTypes.string,
    state: PropTypes.string,
    zip: PropTypes.string
});

export const selfShape = PropTypes.shape({
    enabled: PropTypes.bool,
    dateLastModified: PropTypes.string,
    dateCreated: PropTypes.string,
    accessRights: PropTypes.shape({
        inviteOtherUsers: PropTypes.bool,
        merchantIds: PropTypes.any
    }),
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    cognitoSub: PropTypes.string,
    userName: PropTypes.string,
    accountAgreement: PropTypes.any,
    phone: PropTypes.string
});

export const transactionCustomerShape = PropTypes.shape({
    company: PropTypes.string,
    customerRef: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    email: PropTypes.string,
    firstName: PropTypes.string,
    id: PropTypes.number,
    lastName: PropTypes.string,
    phone: PropTypes.string,
    postalCode: PropTypes.string,
    transactionId: PropTypes.number
});

export const transactionPluginShape = PropTypes.shape({
    description: PropTypes.string,
    id: PropTypes.number,
    invoice: PropTypes.string,
    orderNumber: PropTypes.string,
    originalId: PropTypes.string,
    transactionId: PropTypes.number,
    userId: PropTypes.number
});

export const reserveActivityShape = PropTypes.shape({
    id: PropTypes.number,
    reportDate: PropTypes.string,
    merchantId: PropTypes.string,
    merchantName: PropTypes.string,
    amount: PropTypes.number,
    ddaActionId: PropTypes.number,
    description: PropTypes.string,
    action: PropTypes.string
});

export const reserveSummaryShape = PropTypes.shape({
    merchantId: PropTypes.string,
    amount: PropTypes.number
});

export const transactionGatewayShape = PropTypes.shape({
    gatewayType: PropTypes.number,
    id: PropTypes.number,
    refNumber: PropTypes.string,
    transactionId: PropTypes.number
});

export const transactionProcessorShape = PropTypes.shape({
    id: PropTypes.number,
    originalId: PropTypes.number,
    processorType: PropTypes.number
});

export const transactionKountShape = PropTypes.shape({
    id: PropTypes.number,
    rules: PropTypes.string,
    status: PropTypes.string
});

export const transactionShape = PropTypes.shape({
    amount: PropTypes.number,
    authCode: PropTypes.string,
    achDetailId: PropTypes.string,
    cardHolder: PropTypes.string,
    cardNumber: PropTypes.string,
    cardType: PropTypes.number,
    createdAt: PropTypes.string,
    currencyCode: PropTypes.string,
    customer: transactionCustomerShape,
    gateway: transactionGatewayShape,
    id: PropTypes.number,
    kount: transactionKountShape,
    merchantId: PropTypes.string,
    plugin: transactionPluginShape,
    processMethod: PropTypes.number,
    processor: transactionProcessorShape,
    transactionDate: PropTypes.string,
    transactionStatus: PropTypes.number,
    transactionType: PropTypes.number,
    updatedAt: PropTypes.string
});

export const defaultErrorShape = PropTypes.shape({
    message: PropTypes.string
});

export const goBackTargetShape = PropTypes.shape({
    title: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired
});

export const historyShape = PropTypes.shape({
    goBack: PropTypes.func,
    push: PropTypes.func,
    replace: PropTypes.func
});

export const exportsAvailableShape = PropTypes.shape({
    reportName: PropTypes.string,
    dateCreated: PropTypes.string,
    status: PropTypes.string,
    expiration: PropTypes.string,
    action: PropTypes.string
});

export const recoveriesSummaryShape = PropTypes.shape({
    reportDate: PropTypes.string,
    merchantName: PropTypes.string,
    amount: PropTypes.number
});

export const payoutShape = PropTypes.shape({
    id: PropTypes.number,
    payoutStatus: PropTypes.number,
    transferStatus: PropTypes.number,
    recipientRef: PropTypes.string,
    providerRecipientRef: PropTypes.string,
    batchRef: PropTypes.string,
    amount: PropTypes.number,
    currencyId: PropTypes.string,
    description: PropTypes.string,
    payoutDate: PropTypes.string,
    payoutRef: PropTypes.string,
    payoutProviderRef: PropTypes.string,
    payoutProviderAdditionalRef: PropTypes.string,
    email: PropTypes.string,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    phoneNumber: PropTypes.string,
    mobileNumber: PropTypes.string,
    addressLine1: PropTypes.string,
    addressLine2: PropTypes.string,
    city: PropTypes.string,
    region: PropTypes.string,
    postalCode: PropTypes.string,
    country: PropTypes.string,
    countryOfBirth: PropTypes.string,
    countryOfNationality: PropTypes.string,
    providerResponse: PropTypes.string,
    recipientId: PropTypes.number,
    providerId: PropTypes.number,
    payoutAccountId: PropTypes.number,
    providerType: PropTypes.number
});

export const payoutBatchDetailsShape = PropTypes.shape({
    id: PropTypes.number,
    batchId: PropTypes.number,
    providerType: PropTypes.number,
    providerId: PropTypes.number,
    currency: PropTypes.string,
    processedCount: PropTypes.number,
    processedAmount: PropTypes.number,
    failedCount: PropTypes.number,
    failedAmount: PropTypes.number,
    createdAt: PropTypes.string,
    updatedAt: PropTypes.string
});

export const payoutBatchShape = PropTypes.shape({
    id: PropTypes.number,
    batchRef: PropTypes.string,
    payoutCount: PropTypes.number,
    processedPayoutCount: PropTypes.number,
    failedPayoutCount: PropTypes.number,
    badPayoutRequestCount: PropTypes.number,
    batchProcessingStatus: PropTypes.string,
    payoutAccountId: PropTypes.number,
    initialBatchDate: PropTypes.string,
    createdAt: PropTypes.string,
    updatedAt: PropTypes.string,
    batchDetails: PropTypes.arrayOf(payoutBatchDetailsShape)
});

export const spendbackShape = PropTypes.shape({
    id: PropTypes.number,
    spendbackStatus: PropTypes.number,
    spendbackRef: PropTypes.string,
    providerSpendbackRef: PropTypes.string,
    amount: PropTypes.number,
    currencyId: PropTypes.string,
    description: PropTypes.string,
    spendbackDate: PropTypes.string,
    providerResponse: PropTypes.string,
    recipientRef: PropTypes.string,
    recipientId: PropTypes.number,
    providerId: PropTypes.number,
    payoutAccountId: PropTypes.number,
    providerType: PropTypes.number
});

export const payoutRecipientShape = PropTypes.shape({
    id: PropTypes.number,
    recipientRef: PropTypes.string,
    providerRecipientRef: PropTypes.string,
    recipientId: PropTypes.number,
    providerId: PropTypes.number,
    payoutAccountId: PropTypes.number,
    providerType: PropTypes.number,
    email: PropTypes.string,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    userType: PropTypes.string,
    addressLine1: PropTypes.string,
    addressLine2: PropTypes.string,
    city: PropTypes.string,
    region: PropTypes.string,
    postalCode: PropTypes.string,
    country: PropTypes.string,
    phoneNumber: PropTypes.string,
    mobileNumber: PropTypes.string,
    countryOfBirth: PropTypes.string,
    countryOfNationality: PropTypes.string,
    gender: PropTypes.string,
    birthDate: PropTypes.string,
    createdAt: PropTypes.string,
    updatedAt: PropTypes.string,
    recipientRulesMetadata: PropTypes.any,
    recipientIdNumbers: PropTypes.any,
    totalPayoutCount: PropTypes.number,
    totalPayoutAmount: PropTypes.any,
    latestPayout: PropTypes.shape({
        date: PropTypes.string,
        amount: PropTypes.number,
        currency: PropTypes.string
    })
});
